import { get } from "lodash";
import { call, select } from "redux-saga/effects";

import { getEntitySaga } from "./apiSagas.js";
import { createAction } from "../actions/actionUtils.js";
import { ENDPOINTS } from "../actions/actionConstants.js";

import endpointSelector from "../reducers/endpoints/endpointSelector.js";

// -- STATE SELECTORS -- //

const getEndpoints = state => get(state, "endpoints.data", null);

// -- SAGAS -- //

export function* endpointsSaga(action) {
  // console.log("endpointsSaga", action);
  const endpointAction = createAction("CORE_ENDPOINTS", {
    endpoint: "/"
  });

  try {
    yield call(
      getEntitySaga,
      ENDPOINTS,
      {
        showErrorModal: false,
        logActivity: false
      },
      endpointAction
    );
  } catch (err) {
    console.log("ENDPOINT ERROR:", err);
  }
}

// -- HELPER SAGAS -- //

export function* selectEndpointsSaga() {
  return yield select(getEndpoints);
}

export function* selectEndpointByTypeSaga(type) {
  return endpointSelector.selectEndpointByType(yield select())(type);
}

export function* selectOperationByTypeAndNameSaga(type, name) {
  return endpointSelector.selectOperationByTypeAndName(yield select())(
    type,
    name
  );
}
